import request from '@/utils/request';

const projectName = '/api/blade-platform';


export const getItemListPort = () => {
    return request({
        url: `${projectName}/serviceItem/itemlist`,
        method: "get"
    });
};

export const updateStatusPort = (data) => {
    return request({
        url: `${projectName}/serviceItem/updateStatus`,
        method: "post",
        data
    });
};
export const itemDetailPort = (data) => {
    return request({
        url: `${projectName}/serviceItem/itemDetail`,
        method: "post",
        data
    });
};
export const getMpListPort = (data) => {
    return request({
        url: `${projectName}/serviceItem/getMpList`,
        method: "post",
        data
    });
};
export const getMpListNS = (data) => {
    return request({
        url: `${projectName}/serviceItem/getMpListNS`,
        method: "post",
        data
    });
};
export const getServiceTypePort = () => {
    return request({
        url: `${projectName}/serviceItem/getServiceType`,
        method: "get"
    });
};
// 发布最新配置
export const issueNewConfigPort = () => {
    return request({
        url: `${projectName}/serviceItem/issueNewConfig`,
        method: "get"
    });
};

export const updatePort = (data) => {
    return request({
        url: `${projectName}/serviceItem/update`,
        method: "post",
        data
    });
};
